import { render, staticRenderFns } from "./extract-translations.vue?vue&type=template&id=6c177fe0&"
import script from "./extract-translations.vue?vue&type=script&lang=js&"
export * from "./extract-translations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports